import React from "react";
import AnalyticsEvent from "../shared/AnalyticsEvent";

const ExamFeature = (props) => {
  return (
    <div className="row justify-content-center">
      {props.exam.map((val, i) => (
        <div
          className={`col-lg-4 col-md-6`}
          key={i}
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay={val.dataDelay}
        >
          <div className={`block-style-thumb`}>
            <div className="thumbnail">
            <a href={`${val.link}`} className="" target="_blank" rel="noopener noreferrer"
              onClick={() => AnalyticsEvent({
                category: "ExamDownload",
                action: "Click",
                source: `${props.level}`,
                label: `${val.link}`
              })}
              >
                <img src={`${val.img}`} alt="subject" />
              </a>
            </div>
            <h4>{val.title}</h4>
            <a href={`${val.link}`} className="btn" target="_blank" rel="noopener noreferrer"
              onClick={() => AnalyticsEvent({
                category: "ExamDownload",
                action: "Click",
                source: `${props.level}`,
                label: `${val.link}`
              })}
              >
                Download &nbsp;
                <span className="fa fa-download"></span> 
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExamFeature;
